export const storePlayData = [
    {
        "id": 1,
        "image": require("../images/store/store_21.jpeg"),
        "area": "學甲區",
        "name": "光華社區",
        "link": "https://iwind17.com/477/tainan-xuejia-hollyhock/"
    },
    {
        "id": 2,
        "image": require("../images/store/store_22.jpeg"),
        "area": "龍崎區",
        "name": "農會竹炭故事館",
        "link": "https://hardaway.com.tw/blog/post/48621900"
    },
    {
        "id": 3,
        "image": require("../images/store/store_23.jpeg"),
        "area": "佳里區",
        "name": "彼緹娃藝術蛋糕觀光工廠",
        "link": "https://heymumu520.pixnet.net/blog/post/338119889"
    },
    {
        "id": 4,
        "image": require("../images/store/store_24.jpeg"),
        "area": "新化區",
        "name": "虎頭埤全齡式地景遊憩場",
        "link": "https://jimcat711.pixnet.net/blog/post/569849232"
    },
    {
        "id": 5,
        "image": require("../images/store/store_25.jpeg"),
        "area": "白河區",
        "name": "白河蓮花公園",
        "link": "https://q40320103.pixnet.net/blog/post/340279866"
    },
    {
        "id": 6,
        "image": require("../images/store/store_26.jpeg"),
        "area": "北門區",
        "name": "錢來也雜貨店",
        "link": "https://master1999.pixnet.net/blog/post/221801281"
    },
    {
        "id": 7,
        "image": require("../images/store/store_27.jpeg"),
        "area": "新營區",
        "name": "新營鐵道帝景公園",
        "link": "https://mnbv7741.pixnet.net/blog/post/221796343"
    },
    {
        "id": 8,
        "image": require("../images/store/store_28.jpeg"),
        "area": "麻豆區",
        "name": "總爺藝文中心",
        "link": "https://pcychian.pixnet.net/blog/post/92021512"
    },
    {
        "id": 9,
        "image": require("../images/store/store_29.jpeg"),
        "area": "仁德區",
        "name": "牛稠子車站公園",
        "link": "https://ord0932.pixnet.net/blog/post/121760171"
    },
    {
        "id": 10,
        "image": require("../images/store/store_30.jpeg"),
        "area": "仁德區",
        "name": "仁德親子悠遊館",
        "link": "https://mingliketoeat.pixnet.net/blog/post/91273645"
    }
];
